export function logClientError(context, error, extra = {}) {
  console.error(`[PayRocky] ${context}`, {
    message: error?.message || 'Unknown error',
    ...extra,
  });
}

export function getErrorMessage(error, fallback = 'Something went wrong. Please try again.') {
  if (!error) return fallback;
  if (typeof error === 'string') return error;
  if (typeof error.message === 'string' && error.message.trim()) return error.message.trim();
  return fallback;
}

export function getNetworkErrorMessage() {
  return 'Unable to reach the server right now. Check your internet connection or try again shortly.';
}

export function isValidEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
}

export function getPasswordChecklist(password) {
  const value = String(password || '');
  return {
    minLength: value.length >= 8,
    uppercase: /[A-Z]/.test(value),
    lowercase: /[a-z]/.test(value),
    number: /[0-9]/.test(value),
    special: /[^A-Za-z0-9]/.test(value),
  };
}

export function getPasswordValidationMessage(password) {
  const checks = getPasswordChecklist(password);
  if (!checks.minLength) return 'Password must be at least 8 characters.';
  if (!checks.uppercase) return 'Password must include an uppercase letter.';
  if (!checks.lowercase) return 'Password must include a lowercase letter.';
  if (!checks.number) return 'Password must include a number.';
  if (!checks.special) return 'Password must include a special character.';
  return '';
}
